import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ControlVisitaContent } from './components/ControlVisitaContent';

export default function ControlVisitas() {
    return (
        <>
            <MainContent
                component={<ControlVisitaContent />}
                titulo='Control de Visitas'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
